import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "娱乐新闻", to: "/category/entertainment" },
  { label: "社会热点", to: "/category/society" },
  { label: "网络趣闻", to: "/category/netfun" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (q) {
      navigate(`/search?q=${encodeURIComponent(q)}`);
      setMenuOpen(false);
      setKeyword("");
    }
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 border-background-200 backdrop-blur"
          : "bg-background-50 border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* 品牌 */}
          <Link to="/" className="flex items-center gap-2 cursor-pointer shrink-0">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-newspaper-line text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-black text-lg text-foreground-950 tracking-tight">
                51吃瓜官网
              </span>
              <span className="hidden sm:block text-[11px] text-foreground-500 mt-0.5">
                最新娱乐新闻 · 热点资讯平台
              </span>
            </span>
          </Link>

          {/* 桌面导航 */}
          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm rounded-md whitespace-nowrap transition-colors cursor-pointer ${
                    isActive
                      ? "text-primary-600 font-medium bg-primary-50"
                      : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          {/* 桌面搜索 */}
          <form
            onSubmit={submitSearch}
            className="hidden md:flex items-center gap-2 bg-background-100 border border-background-200 rounded-full pl-3 pr-1 h-10 w-64"
          >
            <i className="ri-search-line text-foreground-400 text-base"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索热点、明星、话题"
              className="flex-1 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 outline-none"
            />
            <button
              type="submit"
              className="h-8 px-3 rounded-full bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              搜索
            </button>
          </form>

          {/* 移动端菜单按钮 */}
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {/* 移动端面板 */}
      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <form onSubmit={submitSearch} className="flex items-center gap-2 mb-3">
            <div className="flex items-center gap-2 flex-1 bg-background-100 border border-background-200 rounded-full pl-3 pr-1 h-10">
              <i className="ri-search-line text-foreground-400 text-base"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索热点、明星、话题"
                className="flex-1 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 outline-none"
              />
            </div>
            <button
              type="submit"
              className="h-10 px-4 rounded-full bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              搜索
            </button>
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 text-sm rounded-md transition-colors cursor-pointer ${
                    isActive
                      ? "text-primary-600 font-medium bg-primary-50"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}